import React from 'react'

import ContactSupportMessage from './ContactSupportMessage'

export interface ErrorUpdatingCartMessageProps {
  withoutContactSupport?: boolean
}

const ErrorUpdatingCartMessage: React.FC<ErrorUpdatingCartMessageProps> = ({
  withoutContactSupport = false,
}) => (
  <React.Fragment>
    An error occurred updating your cart, and we have been notified.{' '}
    {!withoutContactSupport && <ContactSupportMessage />}
  </React.Fragment>
)

export default ErrorUpdatingCartMessage
